import React from 'react';
import { MarketingShell, CONTACT_EMAIL, IMG } from './LandingPage';

const AboutPage: React.FC = () => (
  <MarketingShell
    title="About Us - NAC Easy Solution | Made in Bhutan"
    description="NAC Easy Solution is made in Bhutan for Bhutanese shops — POS, inventory, vendors, and Bhutan GST in Nu."
  >
    <section className="sk-page-hero" style={{ backgroundImage: `url(${IMG.ops})` }}>
      <div>
        <h1>Made in Bhutan, for Bhutanese shops</h1>
        <p>NAC Easy Solution runs your till in Nu. — POS, inventory, vendors, purchase orders, and Bhutan GST in one system built for the Kingdom.</p>
      </div>
    </section>

    <section className="sk-section">
      <div className="sk-grid-3">
        <article className="sk-card">
          <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.gst})` }} />
          <h3>Stay Compliant with Bhutan GST</h3>
          <p>Easily handle Bhutan GST calculations and reporting within our system, ensuring compliance and accurate tax management for your business.</p>
        </article>
        <article className="sk-card">
          <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.branches})` }} />
          <h3>Manage Multiple Branches Seamlessly</h3>
          <p>Keep track of inventory and sales across all your branches with centralized control and real-time data updates.</p>
        </article>
        <article className="sk-card">
          <div className="sk-card-img" style={{ backgroundImage: `url(${IMG.pos})` }} />
          <h3>Point of Sale (POS) System</h3>
          <p>Efficiently process sales transactions with an intuitive POS interface designed for quick and accurate checkout.</p>
        </article>
      </div>
      <div style={{ textAlign: 'center', marginTop: 28 }}>
        <a className="sk-btn" href={`mailto:${CONTACT_EMAIL}`}>Get Started</a>
      </div>
    </section>
  </MarketingShell>
);

export default AboutPage;
